import {
  FormFieldSchema,
  FormFieldType,
  TriggerCondition,
  TriggerType,
} from "@app/components/forms/types/schema";

export const FunctionsSchema: FormFieldSchema[] = [
  { type: FormFieldType.Separator },
  {
    type: FormFieldType.Select,
    id: "postingSort",
    label: "게시 순서",
    description: "게시 순서에 따라 위젯에 표시될 컨텐츠가 순서가 달라집니다.",
    placeholder: "순서 선택",
    layout: "horizontal",
    defaultValue: "latest",
    behavior: {
      required: true,
    },
    appearance: {
      border: false,
    },
    options: [
      {
        label: "최신순",
        value: "latest",
      },
      {
        label: "과거순",
        value: "oldest",
      },
      {
        label: "조회순",
        value: "view_count",
      },
      {
        label: "무작위",
        value: "random",
      },
    ],
  },
  { type: FormFieldType.Separator },
  {
    type: FormFieldType.Select,
    id: "preview",
    label: "미리보기 방식",
    description: "미리보기 방식을 선택하세요.",
    placeholder: "미리보기 방식 선택",
    layout: "horizontal",
    defaultValue: "focus",
    behavior: {
      required: true,
    },
    options: [
      {
        label: "포커스 모드",
        value: "focus",
        description: "마우스 호버 시 프리뷰가 재생됩니다.",
      },
      {
        label: "슬라이드 모드",
        value: "slider",
        description: "프리뷰가 하나씩 재생되면서 슬라이딩 되고 포커스됩니다.",
      },
    ],
  },
  {
    type: FormFieldType.Switch,
    id: "customizePreviewDuration",
    label: "미리보기 시간 설정",
    description: (
      <p>
        컨텐츠 미리 보기 시간을 설절할 수 있습니다.
        <br />
        기본값은 <b>비디오 7초</b>, <b>이미지 3초</b> 입니다.
      </p>
    ),
    defaultValue: false,
    appearance: {
      border: false,
    },
  },
  {
    type: FormFieldType.Group,
    id: "previewDuration",
    noneStyle: true,
    behavior: {
      triggers: [
        {
          type: TriggerType.Show,
          field: "customizePreviewDuration",
          value: true,
          condition: TriggerCondition.Equal,
        },
      ],
    },
    schemas: [
      {
        type: FormFieldType.Number,
        id: "videoPreviewDuration",
        label: "비디오 미리보기 시간",
        description: "설정한 시간(초) 만큼 비디오의 미리보기를 재생합니다.",
        layout: "horizontal",
        defaultValue: "7",
        min: 1,
        max: 60,
      },
      {
        type: FormFieldType.Number,
        id: "imagePreviewDuration",
        label: "이미지 미리보기 시간",
        description: "설정한 시간(초) 만큼 이미지의 미리보기를 재생합니다.",
        layout: "horizontal",
        defaultValue: "3",
        behavior: {
          required: true,
        },
        min: 1,
        max: 10,
      },
    ],
  },
  { type: FormFieldType.Separator },
  {
    type: FormFieldType.Switch,
    id: "unmuteVideoByDefault",
    label: "영상 재생 시 사운드 켜기",
    description: "영상 재생 시 자동으로 사운드를 켜거나 끌 수 있습니다.",
    defaultValue: true,
    appearance: {
      border: false,
    },
  },
  { type: FormFieldType.Separator },
  {
    type: FormFieldType.Switch,
    id: "showPostingTitle",
    label: "포스팅 제목 표시",
    description: "스토리형 타입의 위젯 제목을 표시하거나 숨길 수 있습니다.",
    defaultValue: true,
    appearance: {
      border: false,
    },
  },
  { type: FormFieldType.Separator },
  {
    type: FormFieldType.Switch,
    id: "loop",
    label: "자동 롤링",
    description:
      "포스팅의 개수가 위젯 영역을 넘어서면 포스팅이 자동으로 돌아가며 보입니다.",
    defaultValue: true,
    appearance: {
      border: false,
    },
  },
  { type: FormFieldType.Separator },
  {
    type: FormFieldType.Select,
    id: "readMarkResetCycle",
    label: "읽음 표시 재생성",
    description: "스토리형 타입의 위젯 제목을 표시하거나 숨길 수 있습니다.",
    placeholder: "선택",
    layout: "horizontal",
    defaultValue: "0",
    appearance: {
      border: false,
    },
    options: [
      {
        label: "읽은 상태 유지",
        value: "none",
        description: "컨텐츠를 보면 읽음 상태 테두리가 사라진 채로 유지됩니다.",
      },
      {
        label: "12시간",
        value: "12",
        description: "12시간 이후 읽음 상태 테두리가 다시 표시됩니다.",
      },
      {
        label: "24시간",
        value: "24",
        description: "24시간 이후 읽음 상태 테두리가 다시 표시됩니다.",
      },
      {
        label: "36시간",
        value: "26",
        description: "36시간 이후 읽음 상태 테두리가 다시 표시됩니다.",
      },
      {
        label: "48시간",
        value: "48",
        description: "48시간 이후 읽음 상태 테두리가 다시 표시됩니다.",
      },
      {
        label: "항상 표시",
        value: "0",
        description: "읽은 상태 테두리가 항상 표시됩니다.",
      },
    ],
  },
  { type: FormFieldType.Separator },
  {
    type: FormFieldType.Switch,
    id: "tagMinimized",
    label: "상품 태그 접기",
    description: "상품 태그를 아이콘 형태로 표시할 수 있습니다.",
    defaultValue: false,
    appearance: {
      border: false,
    },
  },
  { type: FormFieldType.Separator },
  {
    type: FormFieldType.Switch,
    id: "showLikeButton",
    label: "좋아요 버튼 표시",
    description: "좋아요 기능을 사용할 수 있습니다.",
    defaultValue: true,
    appearance: {
      border: false,
    },
  },
  { type: FormFieldType.Separator },
  {
    type: FormFieldType.Switch,
    id: "useSharedLink",
    label: "공유 기능 사용",
    description: "컨텐츠를 공유할 수 있는 기능을 사용할 수 있습니다.",
    defaultValue: true,
    appearance: {
      border: false,
    },
  },
  { type: FormFieldType.Separator },
  {
    type: FormFieldType.Switch,
    id: "restrictGuest",
    label: "비회원 포스팅뷰 제한",
    description: "컨텐츠를 공유할 수 있는 기능을 사용할 수 있습니다.",
    defaultValue: true,
    appearance: {
      border: false,
    },
  },
  { type: FormFieldType.Separator },
  {
    type: FormFieldType.Switch,
    id: "hidePriceToGuest",
    label: "비회원 가격 정보 제한",
    description: "컨텐츠를 공유할 수 있는 기능을 사용할 수 있습니다.",
    defaultValue: true,
    appearance: {
      border: false,
    },
  },
  { type: FormFieldType.Separator },
];
